<template>
  <el-card class="m-b">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">{{orderType == 1 ? '货物' : '服务'}}清单</span>
    </div>
    <div  style="text-align:right;margin-bottom: 20px">
      <el-button type="primary" @click="exportOrderList">导出清单</el-button>
    </div>
    <zl-server-page-table
      :border="false"
      showTotal
      height="400px"
      ref="multipleTable"
      :api="getApi"
    >
      <el-table-column
        v-for="(row, index) in listColumns"
        :key="index"
        :label="row.columnNameCH"
        :prop="row.columnNameEN"
      >
      </el-table-column>
    </zl-server-page-table>
    <div class="order-total-box">
      <p>
        <span>含税总价（元）：</span>
        <span>{{_util.formatMoney(totalPrice)}}</span>
      </p>
      <p v-if="system === 'purchaser'">
        <span>订单预算（元）：</span>
        <span>{{_util.formatMoney(secondInfo.budgetAmount)}}</span>
      </p>
    </div>
  </el-card>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    orderType: {
      type: [Number, String],
      default: 1
    },
    secondInfo: {
      type: Object,
      default: () => ({})
    },
    columnString: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      system: this.$store.state.system, // 当前登录的是哪个系统
      isSubmitData: false, // 当前页面是否是待提交的数据  只针对采购人
      tableList: []
    }
  },
  computed: {
    totalPrice() {
      let total = 0
      this.tableList.forEach(val => {
        const money = this.$zl.util.multiply(Number(val.taxUnitPrice), Number(val.amount))
        total = this.$zl.util.add(money, total)
      })
      return total
    },
    listColumns() {
      const result = JSON.parse(this.columnString || '[]')
      return typeof result === 'string' ? [] : result
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions([
      'getListId',
      'pageDdInventoryOrder',
      'pageDdInventoryMainOrder',
      'pageDdInventoryGys',
      'exportDDInventoryMainOrder',
      'exportDDInventoryMainOrderGys'
    ]),
    initData() {
      this.isSubmitData = this.$route.query.status && Number(this.$route.query.status) <= 1003
    },
    async getApi(args) {
      let cacheId
      if (this.isSubmitData) {
        await this.getListId().then((res) => {
          cacheId = res
        })
      }
      let apiName
      if (this.system === 'purchaser') {
      // 待提交的订单数据  还没存进数据库  所以不是调用正式接口
        apiName = this.isSubmitData ? 'pageDdInventoryOrder' : 'pageDdInventoryMainOrder'
      } else {
        apiName = 'pageDdInventoryGys'
      }
      return this[`${apiName}`]({
        id: cacheId,
        unionId: this.$route.query.id,
        loadFromDB: true,
        pageNum: args.page,
        pageSize: args.size
      })
        .then(res => {
        // 返回所有清单数据值，用于计算真个清单的含税总价
          let list = res.list.map(
            (t) => {
              t.rowValue = t.rowValue && JSON.parse(t.rowValue) || {}
              t.rowValue.deliverSize = t.deliverSize || 0
              t.rowValue.arrivalSize = t.arrivalSize || 0
              t.rowValue.checkSize = t.checkSize || 0
              t.rowValue.returnSize = t.returnSize || 0
              t.rowValue.barterSize = t.barterSize || 0
              return t.rowValue
            }
          )
          this.tableList = list
          return {
            rows: list,
            total: res.totalCount
          }
        })
    },
    // 导出订单清单
    exportOrderList() {
      this[`${this.system === 'purchaser' ? 'exportDDInventoryMainOrder' : 'exportDDInventoryMainOrderGys'}`]({
        id: this.$route.query.id
      }).then(res => {
        this.$zl.util.blobDownload(res, '订单清单.xls')
      })
    }
  }
}
</script>
